import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { compose } from 'redux';
import { LayoutWrapperMain, Page, PostDetailInfo } from '../../components';
import config from '../../config';
import './postmanagement.global.scss';

interface Props {
  scrollingDisabled: boolean,
  // from  
  // from injectIntl
  intl: any,
}

const PostManagementComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const params = useParams();
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'PostDetails.info.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <PostDetailInfo id={params.postId} />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const PostManagementComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(PostManagementComponent);

export default PostManagementComponentPage;
